import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import MyNavbar from '../../../components/Customer/Mynavbar/MyNavbar';
import CategoryCircles from '../../../components/Customer/CategoryCircles/CategoryCircles';
import ProductCard from '../../../components/Customer/ProductCard/ProductCard';
import Footer from '../../../components/Customer/Footer/Footer';
import AppContext from '../../../context/AppContext';
import '../../../assests/css/customer/Men/MenPage.css';
import '../../../assests/css/customer/Home/Home.css';

const MenPage = () => {
  const navigate = useNavigate();

  const { baseUrl, selectedCategory } = useContext(AppContext);

  const [wishlist, setWishlist] = useState([]);
  const [cart, setCart] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadAllProductsWithCategory = (category_id, subCat_id) => {
    if (!category_id || !subCat_id) return;

    setAllProducts([]);
    setLoading(true);

    axios
      .post(`${baseUrl}/customer/products/loadAllProductForCustomer`, {
        category_id,
        subcategory_id: subCat_id,
      })
      .then((res) => {
        setAllProducts(res.data.products || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Products loading error:', error);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!selectedCategory?.id) {
      setAllProducts([]);
      return;
    }

    setLoading(true);

    axios
      .post(`${baseUrl}/customer/products/loadAllProductForCustomer`, {
        category_id: selectedCategory.id,
      })
      .then((res) => {
        setAllProducts(res.data.products || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Products loading error:', error);
        setLoading(false);
      });
  }, [selectedCategory, baseUrl]);

  const formatProduct = (product) => {
    const subTitle = (product.subcategory?.title || '')
      .toLowerCase()
      .replace(/[^a-z]/g, '');

    const type =
      subTitle.includes('unstit') || subTitle.includes('unstich')
        ? 'unstitched'
        : 'stitched';

    return {
      ...product,
      images: product.images || [],
      price: product.base_price,
      type,
    };
  };

  const toggleWishlist = (id) =>
    setWishlist((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );

  const toggleCart = (id) =>
    setCart((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );

  const renderSection = (title, products) => (
    <section className="products-collection-section">
      <div className="products-collection-container">
        <h2 className="products-collection-title">{title}</h2>

        {loading && (
          <p style={{ textAlign: 'center', padding: '20px' }}>Loading...</p>
        )}

        <div className="products-grid">
          {products.map((product) => {
            const formattedProduct = formatProduct(product);

            return (
              <ProductCard
                key={product.id}
                product={formattedProduct}
                type={formattedProduct.type}
                wishlist={wishlist}
                toggleWishlist={toggleWishlist}
                cart={cart}
                toggleCart={toggleCart}
                onCardClick={() =>
                  navigate(`/product-detail/${product.id}`)
                }
              />
            );
          })}
        </div>

        {!loading && products.length === 0 && (
          <p style={{ textAlign: 'center', color: '#999' }}>
            No products found.
          </p>
        )}
      </div>
    </section>
  );

  const groupedBySub = {};
  (selectedCategory?.subcategories || []).forEach((sub) => {
    groupedBySub[sub.id] = {
      title: sub.title,
      products: allProducts.filter(
        (p) =>
          p.mlsubcategory_id === sub.id || p.subcategory?.id === sub.id
      ),
    };
  });

  return (
    <div>
      <MyNavbar />
      <br />

      <CategoryCircles
        loadAllProductsWithCategory={loadAllProductsWithCategory}
      />

      {Object.entries(groupedBySub).map(
        ([subId, { title, products }]) => (
          <React.Fragment key={subId}>
            {renderSection(title, products)}
          </React.Fragment>
        )
      )}

      <Footer />
    </div>
  );
};

export default MenPage;
